import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';

// Initialize Bugsnag for client-side error tracking
if (process.env.NEXT_PUBLIC_BUGSNAG_KEY) {
  Bugsnag.start({
    appType: 'client',
    apiKey: process.env.NEXT_PUBLIC_BUGSNAG_KEY,
    appVersion: process.env.NEXT_PUBLIC_GIT_COMMIT,
    releaseStage: process.env.NEXT_PUBLIC_DEPLOY_NAMESPACE,
    plugins: [new BugsnagPluginReact()]
  });

  // this is still necessary because we have window.Bugsnag.notify calls in the monorepo
  window.Bugsnag = Bugsnag;
}

window.forceDD_RUMError = function () {
  window.DD_RUM?.addError(new Error('forced DD_RUM error'));
};
